import { useEffect, useRef } from "react";
import Modal from "../common/modals";

interface RewardItem {
  action: string;
  reward: {
    amount: number;
    type: "XP" | "Coins";
  };
}

export default function RewardsCriteria({ onClose }: { onClose: () => void }) {
  const modalRef = useRef<HTMLDivElement>(null);

  const rewardsList: RewardItem[] = [
    {
      action: "Voting on a poll",
      reward: { amount: 1, type: "XP" },
    },
    {
      action: "Open News Section once a day",
      reward: { amount: 1, type: "XP" },
    },
    {
      action: "Answering a quiz",
      reward: { amount: 1, type: "XP" },
    },
    {
      action: "Like a Post",
      reward: { amount: 5, type: "XP" },
    },
    {
      action: "Open App Once a day",
      reward: { amount: 10, type: "XP" },
    },
  ];

  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Modal
      isOpen={true}
      size="medium"
      variant="middle"
      customClass="max-w-lg"
      closeOnOverlayClick={true}
      customVariant="top-[55%]"
    >
      <div ref={modalRef} className="space-y-6">
        <h2 className="text-[20px] font-semibold border-b p-6">
          Rewards Criteria
        </h2>

        <div className="space-y-1 px-6">
          <div className="text-[15px] text-gray-500 mb-2">Coins</div>
          <div className="text-[17px] font-semibold">
            Coins are rewarded on hitting XP Milestones
          </div>
        </div>

        <div className="space-y-5 px-6 pb-6">
          <div className="text-[15px] text-gray-500">XP</div>
          {rewardsList.map((item, index) => (
            <div key={index} className="flex justify-between items-center">
              <span className="text-[17px] font-semibold">{item.action}</span>
              <span className="flex items-center gap-1 text-[15px] font-semibold">
                +{item.reward.amount}
                <img
                  src="/assets/icons/star-red.png"
                  alt=""
                  className="ml-2 md:w-4 md:h-4 w-3 h-3"
                />
              </span>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
